import { IconPropsType } from '..';

export const SpadeIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.25392 11.1966C6.83223 11.6668 6.26568 12.0046 5.63121 12.1638C4.99674 12.3231 4.32512 12.2963 3.70757 12.0869C3.09002 11.8776 2.55648 11.4959 2.17941 10.9937C1.80235 10.4916 1.60004 9.89322 1.59998 9.28001C1.59998 7.91297 2.64226 7.03318 4.03198 5.85985C5.24432 4.83585 6.7218 3.58827 7.99998 1.60001C9.27815 3.58827 10.7556 4.83585 11.968 5.85985C13.3577 7.03318 14.4 7.91297 14.4 9.28001C14.3999 9.89322 14.1976 10.4916 13.8205 10.9937C13.4435 11.4959 12.9099 11.8776 12.2924 12.0869C11.6748 12.2963 11.0032 12.3231 10.3687 12.1638C9.73428 12.0046 9.16772 11.6668 8.74603 11.1966C9.15361 12.0595 9.63741 12.8892 10.1924 13.6772C10.4036 13.9759 10.1741 14.4 9.79198 14.4H6.20798C5.82489 14.4 5.5954 13.9759 5.80752 13.6772C6.36255 12.8892 6.84635 12.0595 7.25392 11.1966Z" />
  </svg>
);
